module.exports = __webpack_public_path__ + "img/unistra-fr-pix.0c67f4ee.jpg";